import { ERequestStatus } from '../../types/requestStatus';
import { EPostFormFieldName, IPostFrom } from '../../types/postForm';

export enum EBlogPostFormActionType {
  Loading = 'blogPostForm/loading',
  Succeed = 'blogPostForm/succeed',
  Failed = 'blogPostForm/failed',
  Reset = 'blogPostForm/reset',
}

interface IBlogPostFormLoading {
  type: EBlogPostFormActionType.Loading;
}

interface IBlogPostFormSucceed {
  type: EBlogPostFormActionType.Succeed;
  payload: {};
}

interface IBlogPostFormFailed {
  type: EBlogPostFormActionType.Failed;
}

interface IBlogPostFormReset {
  type: EBlogPostFormActionType.Reset;
}

export type TBlogPostFormActions =
  | IBlogPostFormLoading
  | IBlogPostFormSucceed
  | IBlogPostFormFailed
  | IBlogPostFormReset;

export const initialState: IPostFrom = {
  fields: {
    [EPostFormFieldName.Title]: {
      errorMessage: '',
      required: true,
      value: '',
    },
  },
  formMessage: '',
  formStatus: ERequestStatus.Initial,
};

export const blogPostFormReducer = (state = initialState, action: TBlogPostFormActions) => {
  switch (action.type) {
    case EBlogPostFormActionType.Loading:
      return { ...state, formStatus: ERequestStatus.Loading };

    case EBlogPostFormActionType.Succeed:
      return { ...state, ...action.payload, formStatus: ERequestStatus.Succeed };

    case EBlogPostFormActionType.Failed:
      return { ...state, formStatus: ERequestStatus.Failed };

    case EBlogPostFormActionType.Reset:
      return initialState;

    default:
      return state;
  }
};
